<template>
<b-row class="ot-main-panel no-gutters OT-Edit-Job" v-if="loaded">
    <b-col cols="12 pl-2" md="2">
        <SideBar :job="job"></SideBar>
    </b-col>
    <b-col cols="12 pl-2" md="10" class="OT-RightPanel">
        <b-row>
            <b-col class="OT-tabs">
                <SubNavbar :routes="routes" :job="job"></SubNavbar>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-view :job="job"></router-view>
            </b-col>
        </b-row>
    </b-col>
</b-row>
<b-row class="ot-main-panel no-gutters" v-else-if="not_found">
    <b-col>
        <h1>Job Not Found</h1>
        <p>
            The selected job was not found.
        </p>
    </b-col>
</b-row>

</template>

<script>

import axios from 'axios';
import typeRouteMappings from '@/routing/jobTypeRoutes.js';

import SubNavbar from '@/components/jobEditing/SubnavBar.vue';
import SideBar from '@/components/jobEditing/SideBar.vue';

import JobModel from '@/models/job.js';

export default {

    components: {
        SubNavbar,
        SideBar
    },

    data() {
        return {
            not_found: false,
            loaded: false,
            job: new JobModel(),
        }
    },

    computed: {
        routes() {
            const type = this.job.attributes.job_type;
            const routes = typeRouteMappings[type];
            return routes;
        },

        lastUpdated() {
            return this.job.attributes.date_modified;
        }
    },

    watch: {
        job_id(id) {

            const nId = parseInt(id);

            if (nId !== this.job.id) {
                this.refresh();
            }
        }
    },

    props: {
        job_id: {
            required: true
        }
    },

    methods: {
        refresh() {
            this.loaded = false;
            this.job.fetch(this.job_id)
            .then(() => {
                this.loaded = true;
            });
        },

        savingJob() {
            this.$snotify.info('Saving Job', {
                timeout: 0
            });
        },

        savedJob() {
            this.$snotify.clear();
            this.$snotify.success('Job Saved');
        },

        jobError($e) {
            this.$snotify.clear();
            if ($e.action === 'save') {
                this.$snotify.error($e.details.detail, 'Error Saving Job');
            } else {
                this.$snotify.error($e.details.detail, 'Error');
            }
        },

        jobNotFound() {
            this.loaded = false;
            this.not_found = true;
        }
    },

    created() {
        this.refresh();

        this.job.on('saving', this.savingJob);
        this.job.on('saved', this.savedJob);
        this.job.on('error', this.jobError);
        this.job.on('not-found', this.jobNotFound);
    },

    beforeDestroy() {
        this.job.off('saving', this.savingJob);
        this.job.off('saved', this.savedJob);
        this.job.off('error', this.jobError);
        this.job.off('not-found', this.jobNotFound);
    }
}
</script>
